import { NotificationType } from "@/domains/notification/constants/notificationType";
import { Profession } from "@/domains/notification/constants/profession";
import { Skill } from "@/domains/notification/constants/skill";

export const fakeNotifications = [
  {
    type: NotificationType.PlayerLevel,
    state: {
      level: 4,
      increase: true,
      points: [10, 20],
    },
  },
  {
    type: NotificationType.Skill,
    state: { skill: Skill.Lungs, percent: 50 },
  },
  {
    type: NotificationType.Profession,
    state: { profession: Profession.BusDriver, level: [5, 10] },
  },
  {
    type: NotificationType.QuestSuccess,
    state: {
      questName: "Dragon Slayer",
      donat: 100,
      money: 5000,
      thing: 3,
      exp: 1500,
    },
  },
  {
    type: NotificationType.QuestError,
    state: {
      questName: "Dragon Slayer",
      rewards: 1000,
    },
  },
];
